module.exports = __webpack_public_path__ + "static/media/sidemenu_preorder_pickup.e0dc8fca.svg";